/* eslint-disable jsx-a11y/alt-text */
import React, { PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class ItemBox extends PureComponent {
  componentDidMount = () => {
    // const { i } = this.props.childProps;
    //console.log('===>' + i)
  };
  /*
    UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
        //console.log(this.props.location.pathname)
        //console.log(nextProps.location)
        return (this.props.childProps.i !== nextProps.childProps.i)
        //return true;
    }
    componentWillReceiveProps = (nextProps) => {
        console.log(this.props.childProps.i, nextProps.childProps.i)
        if(this.props.childProps.i !== nextProps.childProps.i) {
            console.log('change box....')
          
          
        } else {
            console.log('no box....')
        }
    }
    */
  _renderItem = () => {
    const { charList } = this.props.childProps;

    const list = charList.map((item, index) => {
      const pos = item.stepName.indexOf("(");
      const stepName = item.stepName.substr(0, pos);
      let title;
      if (item.title.length > 10) {
        title = item.title.substr(0, 10) + "...";
      } else {
        title = item.title;
      }
      return (
        <li key={index}>
          <div className={`rank rank0${index + 1}`} key={index}>
            <span className="badge">{index + 1}</span>
            <div className="thumb">
              <img
                src={`https://ah9szoaj9w.ecn.cdn.ofs.kr/tvee-admin/content/data/${item.stepImage}`}
              />
            </div>
            <div className="txtbox">
              <span className="name">{stepName}</span>
              <span className="ani">{title}</span>
            </div>
          </div>
        </li>
      );
    });

    return list;
  };
  render() {
    const { charList } = this.props.childProps;
    //console.log(charList)
    return (
      <ul className="rank_list">{charList ? this._renderItem() : null}</ul>
      /*<div style={{ color: '#fff', height: 100}}>item{i}</div>*/
    );
  }
}

export default shopContext(withRouter(ItemBox));
